<template>
  <div>
    <public-title v-if="!roomStatus">待确认列表</public-title>
    <!--订单分类-->
    <div class="bg-white load-area" ref="scrollWrap">
        <ul class="order-tab mb-3" v-if="!roomStatus">
            <li v-for="(tab,index) in tabArr()" :key="tab.status" :class="{'tab-active':tab.status==formData.status}" @click="changeTab(tab.status,index)">
                <i :class="tab.icon " class="iconfont"></i>
                {{ tab.title }}
                <span v-if="showUnread(tab)>0" class="order-num" :class="tab.color">{{showUnread(tab)>99?'99+':showUnread(tab)}}</span>
            </li>
        </ul>
        <!--订单列表-->
        <template v-if="total>0&&!loading">
            <OrderList :orderList="orderList" class="mt-3" @getOrderFlag="getOrderFlag" @openFinance="openFinance" @uploadInvoice="uploadInvoice" :confirm="true"></OrderList>
            <!--分页-->
            <div class="el-pagination">
                <el-pagination background layout="total,prev, pager, next" 
                    :page-size="10"
                    :total="total" :current-page="Number(formData.page)"
                    @current-change="$GFUN.pageChange"/>
            </div>
        </template>
        <!--没有搜索到相关结果-->
        <div class="itemcard" v-if="orderList.length==0&&!loading">
            <div class="no-search-result">
            <img src="/images/order/icon_22.png"/>
            <div class="no-search-text">
                <p class="one">暂无相关订单。</p>
                <p class="two">请稍后再试</p>
                <el-button type="primary" @click="clearSearch" v-if="Object.keys(this.searchCon).length > 0"    class="no-button">清除选项</el-button>
            </div>
            </div>
        </div>
        <!--骨架屏-->
        <div class="loading" v-if="loading">
            <Spinner></Spinner>
        </div>
        <!--订单标记-->
        <el-dialog  :visible.sync="showFlagPanel" width="600px" center id="loadConfirm" title="订单标记">
            <Flag :flagtiem='flagtiem' :flagtype='flagtype' @close="showFlagPanel=!showFlagPanel" @list="initial()"></Flag>
        </el-dialog>
        <!--提交财务-->
        <el-dialog title="提交财务" :visible.sync="finance" width="340px" class="paymentist" :close-on-click-modal="false" top="16%">
            <commission  @finance="finance=!finance" :oid="financeprice.oid" :price_pay="financeprice.price_pay" @submitFinance="submitFinance"></commission>
        </el-dialog>
        <!--上传发票-->
        <OrderuploadInvoice :invoiceType="invoiceType" :onShow="uploadInvoiceShow" :editMode="editMode||isAdmin" :orderDetail="orderDetail" @isClick="isClick=false"  :existImgs="existImgs" @onShow="uploadInvoiceShow=!uploadInvoiceShow" @getorderDetail="$emit('getOrderList',true)" />
    </div>  
  </div>
</template>

<script>
 import SearchCon from '../Components/SearchCon'                    //订单搜索组件
 import OrderList from '../Components/List'                         //订单列表组件
 import Flag from '../Components/Flag'                              //订单标记组件
 import Spinner from '../Components/Spinner'                    //骨架屏组件
 import commission from '../../Admin/FinancialManage/Subassembly/commission.vue'                      //提交财务组件
 import OrderuploadInvoice from '@/views/Order/OrderDetail/HotelOrder/Components/OrderuploadInvoice'; //上传发票弹窗
 import { mapGetters,mapState,mapActions } from 'vuex'
 import { debounce } from "lodash";
export default {
  name: '',
  components: {
    SearchCon,
    OrderList,
    Flag,
    commission,
    OrderuploadInvoice,
    Spinner,
  },
  props: {
    roomStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
        formData:{
            page:1,
            num:10,
            flag:1,
        },
        //搜索条件
        searchCon:{},
        //总条数
        total:0,
        //当前列表
        orderList:[],
        orderType:[{
            title:'全部订单',
        }],
        //当前索引
        orderIndex:0,
        loading:true, //加载中
        //标记数量
        infoNum:{
            status_today:0,
            status_7:0,
            status_8:0,
            status_6:0,
        },
        //订单标记弹窗
        showFlagPanel:false,
        flagtiem:{},
        flagtype:'',
        //提交财务弹窗
        finance:false,
        financeprice:{
            oid:'',
            price_pay:0,
        },
        //上传发票弹窗
        uploadInvoiceShow:false,                     //上传发票弹窗
        editMode:false,                              //是否编辑发票
        existImgs:'',                                //已存在发票
        isClick:false,                               //禁止连续点击
        invoiceType:'',                              //发票点击的身份值
        orderDetail:{},                             //订单详情
    };
  },
  computed: {
     ...mapGetters(['storeInfo', 'userInfo', 'isAdmin', 'isGroup']),
     ...mapState(['OrderNumInfo','IndexData']),
  },
  watch: {
    newMessageInform(newVal) {
        //收到通知刷新当前页面
        if (newVal && this.$GFUN.isInArray([39,40,42,43,46,47],newVal.type)){
            this.initial();
        }
    },
    '$route.query':{
        handler(toVal,fromVal){
            this.formData.page=toVal.page||1;
            this.formData.status=toVal.status||5;
            this.orderIndex= toVal.index||0;
            this.initial();
        },
        immediate:true
    }
  },
  created() {},
  mounted() {
  },
  methods: {
    ...mapActions(['POST_OrderHotelListConfirm','POST_OrderHotelList','adminSubmitFinance','getUserIndexData','POST_OrderHotelListConfirmHandle']),
        //切换搜索分类
        tabArr() {  
            let tabArr = [
                {title: '确认中', status: '5' ,icon:'icon-daiqueren',value:'confirm_doing',tus:{flag:1}},
                {title: '修改中', status: 'edit_status',value:'edit_doing',icon:'icon-zhengdanweihuyichang',color:'green',tus:{edit_status:1},admintu:{flag:2}},
                {title: '取消中', status: 'cancel_status',value:'cancel_doing',icon:'icon-daishenpi',color:'green',tus:{cancel_status:1},admintu:{flag:3}},
            ]
            return tabArr
        },
        //初始化
        initial(){
            this.formData={...this.formData,...this.searchCon}
            this.list();
        },
        //获取订单列表
        list: debounce(function(){
            let url='POST_OrderHotelList',data={...this.formData};
            this.loading = true;
            if(data.status=='5'||this.isAdmin){
                url='POST_OrderHotelListConfirm'
            }
            if(this.roomStatus){
                url='POST_OrderHotelListConfirmHandle';
            }
            delete data.status;
            data={...data,...this.tabArr()[this.orderIndex][this.isAdmin?'admintu':'tus']||{}}
            this[url]({ 
                data:this.$_Object.removeEmptyProps(data),
                successFun:(res)=>{
                    const scrollRef = this.$refs.elScroll;;
                    // 取 $refs.wrap
                    if (scrollRef ) {
                        scrollRef.$refs.wrap.scrollTop = 0
                    }
                    this.total = res.count;
                    this.orderList = res.list;
                    this.loading = false;   
                }
            })
        },500),
        //切换搜索分类
        changeTab(status,index){
            this.formData.page=1;
            delete this.formData.cancel_status;
            delete this.formData.edit_status;
            this.orderIndex=index;
            //保存到路由
            this.$router.push({
                name: this.$route.query.name,
                query: {status:status, page: 1,index:index}
            })

            this.formData.status=status;
            this.searchCon={};
        },
        /*根据条件搜索订单*/
        getSearchCon(con) {
            this.searchCon = con||{};
            if (this.formData.page == 1) {this.initial()}
            else {
                this.$router.push({
                    name: this.$route.query.name,
                    query: {...this.formData, page: 1}
                })
            };
        },
        //开启订单标记
        getOrderFlag(item,type){
            this.showFlagPanel=true;
            this.flagtiem=item;
            this.flagtype=type;
        },
        /**
         * 开启提交财务弹窗
         */
        openFinance(res){
            let price=0,price_pay=res.price_pay/100;
            if(res.price<price_pay){
                price=res.price
            }else{
                price=price_pay
            }
            this.financeprice={oid:res.oid,price_pay:price_pay};
            this.finance=true;
        },
        /**
         * 管理员提交财务
         */
        submitFinance(ruleForm){
            this.finance=!this.finance
            this.adminSubmitFinance({
                type:3,
                data:ruleForm,
                successFun: () => {
                    this.list();
                    this.getUserIndexData();
                    this._alert('已提交财务，可在待打款列表中查看');
                }
            });
        },
        //开始上传发票
        uploadInvoice(e){
            let editMode=this.isAdmin?true:e.type==this.storeInfo.type;
            if(!this.isClick){
                this.invoiceType=e.type;
                this.editMode=editMode;
                if(this.existImgs===e.receipt||e.receipt==''){
                this.uploadInvoiceShow=true ;
                return;
                }
                this.orderDetail=e.item;
                this.isClick=true;
                this.existImgs=e.receipt;
            } 
        },
        //清除搜索条件
        clearSearch(){
            this.$refs.searchCon.resetSearch();
        },
              //显示待处理订单
      showUnread(item) {
        switch (this.userInfo.type) {
          case 99:
            switch (item.title) {
              case '确认中':
                return this.IndexData.confirming_order_arr.confirm_count;
              case '修改中':
                return this.IndexData.confirming_order_arr.edit_count;
              case '取消中':
                return this.IndexData.confirming_order_arr.cancel_count;
              default:
                return 0;
          }
          case 3:      
          case 2: 
            return this.IndexData.order_arr[item.value]||0;
          default:
            return 0;
        }
      },
  }
};
</script>

<style lang="scss" scoped>
    .load-area{
        background-color:inherit !important;
        padding:0 !important;
        min-width: 1200px;
    }
    .order-tab{
        display: flex;
        justify-content: left;
        width: 100%;    

        box-sizing: border-box;
        li{
            margin-right: 20px;
            padding: 10px 20px;
            background-color: #fff;
            border-radius: 5px;
            display: flex;
            align-items: center;
            color: #666;
            cursor: pointer;
            i{
                margin-right: 5px;
                font-size: 18px;
                margin-top: 2px;
            }
            .order-num{
                margin-left: 10px;
                background-color: red;
                width: 20px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                border-radius: 50%;
                margin-top: 1px;
                font-weight: bold;
                font-size: 11px;
                color: #fff !important;
            }
        }
        .tab-active{
            background-color: var(--smtc-color-primary);
            color: #fff;
        }
    }
    .el-pagination{
        background-color: #fff;
        margin-top:14px;
        padding-bottom:10px;
    }
    .no-search-result{
        width: 100%;
        background-color: #fff;
        box-shadow: 0px 0px 7px #eee;
        border-radius: 16px;
        display: flex;
        justify-content: center;
        padding: 52px 0;
        margin-top: 20px;
        img{
        width: 120px;
        }  
    }
    .no-search-text{
        margin-left: 14px;
        text-align: left;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .one{
        font-weight: bold;
        font-size: 16px;
        }
        .two{
        color: #666;
        margin: 6px 0;
        }
    }
    .img-info{
        display: flex;
        img{
        margin-top: 4px;
        margin-right: 8px;
        }
    }
    .no-button{
        width: 120px;
        padding: 8px 0;
    }
</style>
